<template>
  <v-menu open-on-hover top offset-y max-width="265">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <slot></slot>
      </span>
    </template>

    <v-card>
      <v-card-text>
        <div class="d-flex flex-column">
          <router-link class="no-text-decoration" :to="goToProfile()">
            <div class="cursor-pointer">
              <UserAvatar size="66px" fontSize="20px" :account="account" />
            </div>
          </router-link>
          <div class="d-flex flex-column mt-2">
            <router-link class="router-link" :to="goToProfile()">
              <span
                class="name text-subtitle-2 font-weight-bold grey--text text--darken-4 cursor-pointer"
              >
                {{ getFullName(account) }}
              </span>
            </router-link>

            <span
              v-if="account.displayname || account.familyname"
              class="text-body-2 blue-grey--text text--darken-1 break-word text-truncate mt-1"
            >
              {{ account.email }}
            </span>

            <span
              v-if="account.position"
              class="text-caption blue-grey--text text--darken-2 break-word text-truncate mt-1"
            >
              {{ account.position }}
            </span>
          </div>

          <UserRoleChips class="mt-4" :account="account" />
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import userMixin from '@/mixins/userMixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'
import UserRoleChips from '@/components/UserRoleChips.vue'

export default {
  name: 'UserSummaryPopover',

  props: {
    account: {
      type: Object,
      required: true,
    },
  },

  mixins: [mixin, userMixin],

  components: { UserAvatar, UserRoleChips },

  methods: {
    goToProfile() {
      return `/profile/${this.account?.organization?._id ??
        this.account?.organization}/${this.account?._id}`
    },
  },
}
</script>

<style lang="scss" scoped>
.name:hover {
  color: var(--v-primary-base) !important;
}

.v-application a.router-link {
  text-decoration: none;
}
</style>
